<template>
  <section class="nav-section">
    <nav class="navbar navbar-expand-md navbar-transparent" :class="backbg">
      <div class="container">
        <router-link
          @click.native="clickNav(false)"
          class="navbar-brand px-0 py-0"
          to="/"
          >Top Ringtones
        </router-link>
        <div class="collapse navbar-collapse" v-if="!spread">
          <ul class="navbar-nav ml-auto">
            <li @click="clickNav('about')" class="nav-item">
              <router-link class="nav-link" to="/">ABOUT</router-link>
            </li>
            <li @click="clickNav('contact')" class="nav-item">
              <router-link class="nav-link" to="/contact">CONTACT</router-link>
            </li>
          </ul>
        </div>
        <div class="col-2 col-md-1">
          <button class="side-toggle navbar-toggler" @click="spreadNav">
            <span class="spread">
              <span class="spread-item"></span>
              <span class="spread-item"></span>
              <span class="spread-item"></span>
            </span>
          </button>
        </div>
      </div>
    </nav>
    <div class="fix">
      <div class="side-info" :class="{ 'info-open': spread }">
        <button class="navbar-toggler" @click="spreadNav">
          <span class="close">
            <span class="close-item"></span>
            <span class="close-item"></span>
          </span>
        </button>
        <div class="side-info-content">
          <div class="mobile-menu mean-container">
            <div class="mean-bar">
              <nav class="mean-nav">
                <ul @click="spreadNav">
                  <li @click="clickNav('about')">
                    <router-link class="nav-link page-scroll" to="/"
                      >ABOUT</router-link
                    >
                  </li>
                  <li @click="clickNav('contact')">
                    <router-link class="nav-link page-scroll" to="/contact"
                      >CONTACT</router-link
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      spread: false,
      backbg: "",
      scrollTop: 0
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        this.backbg = val.path !== "/" && this.scrollTop > 80 ? "backbg" : "";
        if (val.redirectedFrom === "/contact") {
          this.clickNav("contact");
        }
      },
      immediate: true
    }
  },
  methods: {
    spreadNav() {
      this.spread = !this.spread;
    },
    clickNav(val) {
      if (val) {
        setTimeout(() => {
          const dom = document.querySelector("#" + val);
          const domTop = dom && dom.getBoundingClientRect().top;
          const scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop;
          const navBarHeight =
            document.querySelector(".navbar").offsetHeight || 80;
          window.scrollTo(0, domTop + scrollTop - navBarHeight + 5);
        }, 0);
      } else {
        setTimeout(() => {
          window.scrollTo(0, 0);
        });
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.backbg = this.scrollTop < 80 ? "" : "backbg";
    });
  }
};
</script>

<style lang="scss">
.nav-section {
  position: fixed !important;
  left: 0;
  top: 0;
  right: 0;
  z-index: 200;
}
.navbar {
  padding: 20px !important;
  &.backbg {
    background: $head-background !important;
  }
  .nav-link,
  .navbar-brand {
    color: #fff;
  }
  .navbar-brand {
    font-size: 24px;
  }
}
.navbar-toggler {
  border: none;
  outline: none;
  background-color: transparent;
  .spread {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    height: 30px;
    .spread-item {
      width: 26px;
      height: 3px;
      border-radius: 1px;
      background: $white;
    }
  }
  .close {
    height: 30px;
    width: 30px;
    display: flex;
    flex-direction: column;
    position: relative;
    .close-item {
      width: 30px;
      height: 3px;
      border-radius: 1px;
      background: $white;
      transform-origin: center center;
      position: absolute;
      opacity: 1;
      left: 50%;
      top: 50%;
      &:first-child {
        transform: translate(-50%, -50%) rotate(45deg);
      }
      &:last-child {
        transform: translate(-50%, -50%) rotate(135deg);
      }
    }
  }
}
</style>
